import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Element, Events, scrollSpy, scroller } from "react-scroll";

import { Button, CartItem, Price, Iframe } from "../components";
import { clearCart, removeCartItem, plusCartItem, minusCartItem } from "../actions/cart";
import cartEmpty from "../assets/img/cart-empty.png";

import PayByWidget from "../components/widget-pay";
import CheckoutPay from "../components/checkout-pay";

const Cart = () => {
  let history = useHistory();

  const dispatch = useDispatch();
  const { totalPrice, totalCount, items } = useSelector(({ cart }) => cart);
  const method = useSelector(({ cart }) => cart.methodPay);
  const [iframeUrl, setIframeUrl] = useState("");

  // const [email, setEmail] = useState("");
  // const [paymentResult, setPaymentResult] = useState(null);

  const handlerListener = ({ data }) => {
    // setPaymentResult(() => data.paymentResult.success);
    const { paymentResult, trigger } = data;
    const { success } = paymentResult;

        console.log(data, trigger, success);

    switch (method) {
      case "widget": {
        if (trigger === "closeFrame" && success) {
          dispatch(clearCart());
          history.push('/status');
        }
        break;
      }

      case "checkout": {
        if (success) {
          setTimeout(() => {
            dispatch(clearCart());
            history.push('/status');
          }, 1500);
        }
        break;
      }

      default:
        break;
    }
  };

  useEffect(() => {
    document.title = "theMAP-Store | Корзина";
    window.addEventListener("message", handlerListener);

    Events.scrollEvent.register("begin", function () {});
    Events.scrollEvent.register("end", function () {});
    scrollSpy.update();

    return () => {
      window.removeEventListener("message", handlerListener);

      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  // const handleInput = (e) => {
  //   setEmail(e.target.value);
  // };

  const addedProducts = Object.keys(items).map((key) => {
    return items[key].items[0];
  });

  const onRemoveItem = (id) => {
    if (window.confirm("Вы действительно хотите удалить?")) {
      dispatch(removeCartItem(id));
    }
  };

  const onPlusItem = (id) => {
    dispatch(plusCartItem(id));
  };

  const onMinusItem = (id) => {
    dispatch(minusCartItem(id));
  };

  const onClearCart = () => {
    if (window.confirm("Вы действительно хотите очистить корзину?")) {
      dispatch(clearCart());
    }
  };

  const onClickOrder = () => {
    if (method === "widget") PayByWidget(totalPrice);
    else {
      CheckoutPay(totalPrice).then(({ data }) => {
        if (data.SessionGUID) {
          setIframeUrl("https://api-stage.mapcard.pro/CreatePayment?SessionID=" + data.SessionGUID);
          scrollTo();
        }
      });
    }
  };

  const scrollTo = () => {
    scroller.scrollTo("iframe", {
      duration: 800,
      delay: 500,
      smooth: "easeInOutQuart",
    });
  };

  return (
    <div className="container grid center">
      {totalCount ? (
        <div className="cart">
          <div className="cart__header grid between cross-center">
            <h2>Ваш заказ</h2>
            <div className="cart__clear grid cross-center" onClick={onClearCart}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.5 5H4.16667H17.5"
                  stroke="#B6B6B6"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.66663 5.00001V3.33334C6.66663 2.89131 6.84222 2.46739 7.15478 2.15483C7.46734 1.84227 7.89127 1.66667 8.33329 1.66667H11.6666C12.1087 1.66667 12.5326 1.84227 12.8451 2.15483C13.1577 2.46739 13.3333 2.89131 13.3333 3.33334V5.00001M15.8333 5.00001V16.6667C15.8333 17.1087 15.6577 17.5326 15.3451 17.8452C15.0326 18.1577 14.6087 18.3333 14.1666 18.3333H5.83329C5.39127 18.3333 4.96734 18.1577 4.65478 17.8452C4.34222 17.5326 4.16663 17.1087 4.16663 16.6667V5.00001H15.8333Z"
                  stroke="#B6B6B6"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.33337 9.16667V14.1667"
                  stroke="#B6B6B6"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.6666 9.16667V14.1667"
                  stroke="#B6B6B6"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Очистить корзину</span>
            </div>
          </div>
          <div className="cart__items">
            {addedProducts.map((obj) => (
              <CartItem
                key={obj.id}
                id={obj.id}
                img={obj.img}
                style={obj.style}
                name={obj.name}
                totalCount={items[obj.id].items.length}
                totalPrice={items[obj.id].totalPrice}
                onRemove={onRemoveItem}
                onMinus={onMinusItem}
                onPlus={onPlusItem}
              />
            ))}
          </div>
          <div className="cart__footer ver-margin-30">
            <div className="cart__footer-details grid between cross-top">
              <div>
                <div>
                  <span>Всего выбрано:</span>
                  <span className="hor-margin-10">
                    <strong>{totalCount} шт.</strong>
                  </span>
                </div>
                <div className="ver-margin-5">
                  <span>Способ оплаты:</span>
                  <span className="hor-margin-10">
                    <strong>{method}</strong>
                  </span>
                </div>
              </div>
              <div>
                <span className="hor-margin-10">Сумма заказа:</span>
                <strong>
                  <Price price={totalPrice} />
                </strong>
              </div>
            </div>
            <div className="cart__footer-buttons grid between cross-center">
              <Button classes="btn--outline goback" onClick={() => history.goBack()}>
                <svg height="16" fill="#b6b6b6" width="16" viewBox="0 0 447.243 447.243">
                  <g>
                    <path
                      d="M420.361,192.229c-1.83-0.297-3.682-0.434-5.535-0.41H99.305l6.88-3.2c6.725-3.183,12.843-7.515,18.08-12.8l88.48-88.48
			c11.653-11.124,13.611-29.019,4.64-42.4c-10.441-14.259-30.464-17.355-44.724-6.914c-1.152,0.844-2.247,1.764-3.276,2.754
			l-160,160C-3.119,213.269-3.13,233.53,9.36,246.034c0.008,0.008,0.017,0.017,0.025,0.025l160,160
			c12.514,12.479,32.775,12.451,45.255-0.063c0.982-0.985,1.899-2.033,2.745-3.137c8.971-13.381,7.013-31.276-4.64-42.4
			l-88.32-88.64c-4.695-4.7-10.093-8.641-16-11.68l-9.6-4.32h314.24c16.347,0.607,30.689-10.812,33.76-26.88
			C449.654,211.494,437.806,195.059,420.361,192.229z"
                      strokeWidth="1.8"
                    />
                  </g>
                </svg>
                <span>Вернуться</span>
              </Button>
              <div className="grid">
                {/* <div className="email">
                  <input
                    type="email"
                    value={email}
                    onChange={handleInput}
                    className="cart__email ver-margin-20"
                    placeholder="Введите ваш email"
                  />
                </div> */}
                <Button onClick={onClickOrder} classes="pay-btn ver-margin-20" disabled={iframeUrl !== ""}>
                  <span>Оплатить сейчас</span>
                </Button>
              </div>
            </div>
          </div>
          <div className="grid center themap__checkout">
            {iframeUrl && (
              <Element name="iframe">
                <Iframe url={iframeUrl} />
              </Element>
            )}
          </div>
        </div>
      ) : (
        <div className="cart cart--empty text-center">
          <h2>Корзина пустая</h2>
          <p className="ver-margin-20">
            Пожалуйста, вернитесь на главную страницу,
            <br />
            чтобы выбрать необходимые товары.
          </p>
          <div className="ver-margin-50">
            <img width="250" src={cartEmpty} alt="Empty cart" />
          </div>
          <div>
            <Button onClick={() => history.goBack()}>
              <span>Вернуться назад</span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
